export default __webpack_public_path__ + "static/media/kim-crop.170da2e2.png";